// Auto-generated, do not modify directly

import { api } from './api';

export const ApiService = {
    getPing: api('/ping', 'get'),
    postWalletRecharge: api('/api/wallet/recharge', 'post'),
    getUsersById: api('/api/users/{id}', 'get'),
    getUsersByUserIdDocuments: api('/api/users/{userId}/documents', 'get'),
    postUsersByUserIdCreditLimit: api('/api/users/{userId}/credit-limit', 'post'),
    postUsersByUserIdActive: api('/api/users/{userId}/active', 'post'),
    postSupportsRequest: api('/api/supports/request', 'post'),
    postSettlements: api('/api/settlements', 'post'),
    getQueues: api('/api/queues', 'get'),
    getProfilesDuplicates: api('/api/profiles/duplicates', 'get'),
    postProfilesDuplicate: api('/api/profiles/duplicate', 'post'),
    postPaymentsByIdSend: api('/api/payments/{id}/send', 'post'),
    getPaymentsByIdPdf: api('/api/payments/{id}/pdf', 'get'),
    getPaymentsByIdDownload: api('/api/payments/{id}/download', 'get'),
    postPayments: api('/api/payments', 'post'),
    getPartnersByIdSnapshot: api('/api/partners/{id}/snapshot', 'get'),
    getPartnersByIdIncomplete: api('/api/partners/{id}/incomplete', 'get'),
    getPartnersByIdBalance: api('/api/partners/{id}/balance', 'get'),
    getPartnersByIdAccount: api('/api/partners/{id}/account', 'get'),
    getNotes: api('/api/notes', 'get'),
    postNotes: api('/api/notes', 'post'),
    getLocationsById: api('/api/locations/{id}', 'get'),
    putLocationsById: api('/api/locations/{id}', 'put'),
    deleteLocationsById: api('/api/locations/{id}', 'delete'),
    getLocations: api('/api/locations', 'get'),
    postLocations: api('/api/locations', 'post'),
    postLeadByChannel: api('/api/lead/{channel}', 'post'),
    getJobs: api('/api/jobs', 'get'),
    getJobsByJobIdAssignments: api('/api/jobs/{jobId}/assignments', 'get'),
    postJobsByJobIdAssign: api('/api/jobs/{jobId}/assign', 'post'),
    getCategoriesById: api('/api/categories/{id}', 'get'),
    putCategoriesById: api('/api/categories/{id}', 'put'),
    deleteCategoriesById: api('/api/categories/{id}', 'delete'),
    getCategories: api('/api/categories', 'get'),
    postCategories: api('/api/categories', 'post'),
    getCache: api('/api/cache', 'get'),
    putAssignmentsById: api('/api/assignments/{id}', 'put'),
    postAssignmentsByIdOtpComplete: api('/api/assignments/{id}/otp/complete', 'post'),
    postAssignmentsByIdComplete: api('/api/assignments/{id}/complete', 'post'),
    postAssignmentsByIdAccept: api('/api/assignments/{id}/accept', 'post'),
    postAddressesLatlng: api('/api/addresses/latlng', 'post'),
    postActions: api('/api/actions', 'post'),
    getAuthUser: api('/Auth/user', 'get'),
    postChoresMigrate: api('/Chores/migrate', 'post'),
    getPayments: api('/Payments', 'get'),
    getReportScheduled: api('/api/Report/scheduled', 'get'),
    getReportScheduledPdf: api('/api/Report/scheduled/pdf', 'get'),
    getTags: api('/api/Tags', 'get'),
};
